import { detect } from 'detect-browser'
import MobileDetect from 'mobile-detect'
import DeviceImages from '../assets/DeviceImages'
import CategoryIcons from '../assets/CategoryIcons'
import BrowserIcons from '../assets/BrowserIcons'
import os from 'os'

const BrowserCheck = (props) => {
  const browser = detect()
  const device = new MobileDetect(window.navigator.userAgent)
  const phone = device.phone()
  const tablet = device.tablet()
  const browserVersion = parseFloat(browser.version)

  let deviceType = 'computer'
  let supported = false

  let osVersion = 10

  const OSTest = os.release()
  let regExp = /\(([^)]+)\)/
  let oSString = regExp.exec(OSTest)

  const OsVersion = []
  let osVersionString = ''

  // if windows...
  if ( oSString[1].includes('Windows') ) {
    let windowsString = oSString[1].split(';')
    windowsString = windowsString[0].replace(/[^0-9.]/g, "")
    osVersionString = windowsString
  }

  // if mac..
  if( oSString[1].includes('Macintosh') || oSString[1].includes('iPhone') || oSString[1].includes('iPad') ) {
    let osNumbers = oSString[1].split('_')

    osNumbers.map(each => {
      let myString = each.replace(/[^0-9.]/g, "")
      if ( myString !== '' ) {
        OsVersion.push(myString)
      }
    })

    OsVersion.map((num, idx) => {
      if(idx < 2) {
        let myNum = num.toString()
        let myNumSliced = myNum.slice(0,2)
        if(osVersionString === '') {
          osVersionString = myNum
        } else {
          osVersionString = osVersionString + '.' + myNumSliced
        }
      }
    })
  }

  // google?
  if ( oSString[1].includes('Android') || oSString[1].includes('Linux') ) {
    let windowsString = oSString[1].split(';')
    windowsString = windowsString[1].replace(/[^0-9.]/g, "")
    osVersionString = windowsString
  }


  let theBrowser = browser.name
  const TheVersion = parseInt(browser.version)

  switch (theBrowser) {
    case 'ie':
      if ( TheVersion >= 11 ) {
        supported = true
      }
      break

    case 'edge':
      supported = true
      break

    case 'chrome':
      if ( TheVersion > 60 ) {
        supported = true
      }
      break

    case 'safari':
      if ( TheVersion >= 10 ) {
        supported = true
      }
      break

    case 'ios':
      if ( TheVersion >= 10 ) {
        supported = true
        theBrowser = 'safari'
      }
      break

    case 'crios':
      supported = false
      theBrowser = 'chrome'
    break

    case 'fxios':
      supported = false
      theBrowser = 'firefox'
    break


    default:
      supported = false

  }

  if (phone !== null) {
    deviceType = 'phone'
    supported = true
  } else if (tablet !== null) {
    deviceType = 'tablet'
  }


  let deviceOSName = browser.os.replace(/[0-9]/g, '')

  const DeviceInfo = {
    browserName: theBrowser,
    browserVersion: browser.version,
    deviceType: deviceType,
    deviceOS: deviceOSName,
    osVersion: osVersionString,
    supported: supported
  }

  return DeviceInfo

}

export default BrowserCheck
